import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AnmarApiService } from '../anmar-api.service';
import { AnmarBaseFormComponent } from '../shared/anmar-base-form.component';
import { ANMAR_RESOURCES } from '../shared/anmar-resources';

@Component({
  selector: 'app-about-team-form',
  templateUrl: './about-team-form.component.html',
  styleUrls: ['./about-team-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AboutTeamFormComponent extends AnmarBaseFormComponent {
  config = ANMAR_RESOURCES['aboutTeam'];

  constructor(fb: FormBuilder, api: AnmarApiService, route: ActivatedRoute, router: Router, toastr: ToastrService) {
    super(fb, api, route, router, toastr);
  }

  override submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.toastr.error(this.translate.instant('ANMAR_PAGES.COMMON.REQUIRED_FIELD'), this.translate.instant(this.getModuleTranslateKey()));
      return;
    }

    this.submitting = true;
    const payload = this.buildPayload();
    const request = this.isEditMode && this.recordId
      ? payload instanceof FormData
        ? this.api.updateMultipart(this.config.endpoint, this.recordId, payload)
        : this.api.update(this.config.endpoint, this.recordId, payload)
      : this.api.create(this.config.endpoint, payload);

    request.subscribe({
      next: (response: any) => {
        const updated = this.api.extractItem(response) || {};
        if (updated.image) {
          this.imagePreviewUrls.image = this.api.getImageUrl(String(updated.image));
        }

        this.submitting = false;
        this.toastr.success(
          this.translate.instant(this.isEditMode ? 'ANMAR_PAGES.COMMON.UPDATED_SUCCESS' : 'ANMAR_PAGES.COMMON.CREATED_SUCCESS'),
          this.translate.instant(this.getModuleTranslateKey())
        );
        this.router.navigate(['/anmar', this.config.route]);
      },
      error: (error) => {
        this.submitting = false;
        this.toastr.error(error?.error?.message || this.translate.instant('ANMAR_PAGES.COMMON.ERROR'), this.translate.instant(this.getModuleTranslateKey()));
      }
    });
  }
}
